import React, { useState, useEffect } from "react";
import ReactLoading from 'react-loading';
import "./style.scss";


export const Header = () => {

  return (
    <div className="header">
      <nav id="navbar"
        className="navbar navbar-expand-lg"
        aria-label="Second navbar example"
      >
        <div className="container-fluid">
          <a className="navbar-brand" href="/#">
            Dark Forest
          </a>
        </div>

      </nav>
    </div>
  );
};
